import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from '../modals/DefaultModal';

const CatmatUploadModal = ({ show, onClose, onSuccess }) => {
  const [file, setFile] = useState(null);
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const fileInputRef = useRef(null); // Referência para o campo de entrada de arquivo
  const token = localStorage.getItem('token');

  const handleFileChange = e => {
    setFile(e.target.files[0]);
  };

  const resetModalState = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Limpa o campo de arquivo
    }
  };

  const handleUpload = async () => {
    if (!file) {
      showDefaultModal('error', 'Selecione um arquivo para upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post(`${API_BASE_URL.IMPORT_CATMAT}/importExcel`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (onSuccess) onSuccess();
      showDefaultModal('success', 'Planilha importada com sucesso!');
    } catch (error) {
      console.error('Erro ao enviar o arquivo:', error);
      showDefaultModal('error', 'Erro ao enviar o arquivo.');
    }
  };

  useEffect(() => {
    if (!show) {
      resetModalState();
    }
  }, [show]);

  const handleClose = () => {
    resetModalState();
    onClose();
  };

  return (
    <>
      {/* Modal */}
      <div
        className={`modal fade ${show ? 'show' : ''}`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true" // Indica que este é um modal
        style={{ display: show ? 'block' : 'none' }}
        inert={!show ? '' : undefined} // Desativa interações quando o modal não está visível
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header text-white py-1" style={{ background: 'linear-gradient(90deg, #0b3383, #0e48ad)' }}>
              <h6 className="modal-title text-center m-0">
                Importar Planilha Excel
              </h6>
              <button
                className="btn btn-link text-white p-0 mb-0"
                onClick={handleClose}
                title="Fechar"
                style={{ fontSize: '0.9rem', textDecoration: 'none' }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
            <div className="modal-body">
              <input
                type="file"
                accept=".xlsx"
                className="form-control"
                onChange={handleFileChange}
                ref={fileInputRef} // Associa a referência ao campo de entrada
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleUpload}
              >
                Upload
              </button>
            </div>
          </div>
        </div>
        <DefaultModal {...setDefaultModal} />
      </div>

      {/* Backdrop */}
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default CatmatUploadModal;
